import {
    SALESMAN_PARENTSALESMAN_FILTER,
    SALESMAN_SALESAREA_FILTER,
    SALESMAN_SALESMANCODE_FILTER,
    ROUTE_NO_FILTER,
    SALESMAN_VISITPLAN_FILTER,
    SALESMAN_VISITPLAN_STATUS_FILTER,
    SALESMAN_DISPLAY_FILTER,
    SALESMAN_PRODUCT_DISPLAY_FILTER,
    SALESMAN_TEAM_DISPLAY_FILTER,
    SALESMAN_SEARCH_TRIGGER,
    SALESMAN_PROJECTGROUP_FILTER,
    SALESMAN_PROJECTTYPE_FILTER,
    SALESMAN_PROJECTCATEGORY_FILTER,
    SALESMAN_PROJECTLINE_FILTER,
    SALESMAN_PROJECT_STATUS_FILTER,
    SALESMAN_PROJECT_STAGE_FILTER,
    SALESMAN_PROJECT_LIST_KEYWORD_FILTER
} from '../constants/ActionTypes';

export const salesmanSelectParentSalesman = payload => {
    return {
        type: SALESMAN_PARENTSALESMAN_FILTER,
        payload
    }
}

export const salesmanSelectSalesArea = payload => {
    return {
        type: SALESMAN_SALESAREA_FILTER,
        payload
    }
}

export const salesmanSelectSalesmanCode = payload => {
    return {
        type: SALESMAN_SALESMANCODE_FILTER,
        payload
    }
}

export const routeNoSelectedRouteNo = payload => {
    return {
        type: ROUTE_NO_FILTER,
        payload
    }
}

export const salesmanSelectStartDate = payload => {
    return {
        type: SALESMAN_VISITPLAN_FILTER,
        payload
    }
}

export const salesmanSelectStatus = payload => {
    return {
        type: SALESMAN_VISITPLAN_STATUS_FILTER,
        payload
    }
}

export const salesmanSelectDisplay = payload => {
    return {
        type: SALESMAN_DISPLAY_FILTER,
        payload
    }
}

export const salesmanSelectProductDisplay = payload => {
    return {
        type: SALESMAN_PRODUCT_DISPLAY_FILTER,
        payload
    }
}

export const salesmanSelectTeamDisplay = payload => {
    return {
        type: SALESMAN_TEAM_DISPLAY_FILTER,
        payload
    }
}

export const salesmanSelectProjectGroup = payload => {
    return {
        type: SALESMAN_PROJECTGROUP_FILTER,
        payload
    }
}

export const salesmanSelectProjectType = payload => {
    return {
        type: SALESMAN_PROJECTTYPE_FILTER,
        payload
    }
}

export const salesmanSelectProjectCategory = payload => {
    return {
        type: SALESMAN_PROJECTCATEGORY_FILTER,
        payload
    }
}

export const salesmanSelectProjectLine = payload => {
    return {
        type: SALESMAN_PROJECTLINE_FILTER,
        payload
    }
}

export const salesmanSelectProjectStatus = payload => {
    return {
        type: SALESMAN_PROJECT_STATUS_FILTER,
        payload 
    }
}

export const salesmanSelectProjectStage = payload => {
    console.log("payload" , payload);
    return {
        type: SALESMAN_PROJECT_STAGE_FILTER,
        payload
    }
}



export const salesmanProjectListKeywordFilter = payload => {
    return {
        type: SALESMAN_PROJECT_LIST_KEYWORD_FILTER,
        payload
    }
}

export const salesmanSetSearchTrigger = trigger => {
    return {
        type: SALESMAN_SEARCH_TRIGGER,
        payload: trigger
    }
}